import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

// form to show when new variable is created
export default function APIVariableForm({ variable, onSubmit, onCancel }) {
  const [newvariable, setVariable] = useState(variable);
  const inputRef = useRef(null);

  const handleChange = (e) => {
    setVariable((prev) => {
      if (e.target.type === "checkbox") {
        return {
          ...prev,
          [e.target.name]: !prev[e.target.name],
        };
      }
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    if (inputRef) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  return (
    <div className="new-variable-form" onClick={onCancel}>
      <Draggable onStart={(e) => e.stopPropagation()}>
        <form
          className="form"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(newvariable);
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="padding-5 padding-left-20"
            style={{
              background: " rgb(82, 96, 105)",
              margin: "-30px -30px 10px -30px",
              color: "white",
            }}
          >
            <h4>
              <FontAwesomeIcon icon={faEdit} />
              {` `}
              {variable.value ? `Edit variable` : `Create new variable`}
            </h4>
          </div>
          <div className="form-group">
            <label htmlFor="variableNameInput">
              Variable
              <input
                ref={inputRef}
                id="variableInput"
                type="text"
                name="name"
                value={newvariable.name}
                className="form-control"
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="delimiterInput">
              Variable (delimiter) value
              <input
                id="delimiterInput"
                type="text"
                className="form-control"
                name="delimiter"
                value={newvariable.delimiter}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="endDelimiterInput">
              Variable : value (end delimiter)
              <input
                id="endDelimiterInput"
                type="text"
                className="form-control"
                name="endDelimiter"
                value={newvariable.endDelimiter}
                onChange={handleChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="listDelimiterInput">
              Variable : value (list delimiter) value (list delimiter) value
              <input
                id="listDelimiterInput"
                type="text"
                className="form-control"
                name="listDelimiter"
                value={newvariable.listDelimiter}
                onChange={handleChange}
              />
            </label>
          </div>{" "}
          <div className="form-group">
            <label htmlFor="isMultiLineCheckbox">
              <input
                id="isMultiLineCheckbox"
                type="checkbox"
                name="isMultiLine"
                checked={newvariable.isMultiLine}
                onChange={handleChange}
              />{" "}
              Multi-line variable - find all occurrences. By default we will
              look only for the first instance
            </label>
          </div>
          <div className="form-group">
            {variable.value && (
              <label
                htmlFor="isPermanentCheckbox"
                style={{ width: "fit-content" }}
              >
                <input
                  id="isPermanentCheckbox"
                  type="checkbox"
                  name="isPermanent"
                />
                Make changes permanent
              </label>
            )}
            <button
              type="button"
              className="btn btn-danger  width-100"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-success  width-100">
              {variable.value ? `Update` : `Save`}
            </button>
          </div>
        </form>
      </Draggable>
    </div>
  );
}
